import * as React from 'react';
import style from './HTTPMethodDisplay.scss';
import { Text } from '../../../../../PageElements/Text';

export const HTTPMethodDisplay = ({ method = '' }) => (
  <span
    data-hook="display-method"
    className={`${style.method} ${style[method.toLowerCase()]}`}
  >
    <Text weight="normal" light className={style.methodText} tagName="span">
      {method}
    </Text>
  </span>
);
